import { apiPost, friendlyError, type ApiError } from "../../api/client.js";
import type { GuestInterface } from "./vmUtils.js";

export interface ContainerListItem {
  vmid: number | null;
  name: string;
  node: string;
  status: string;
  creation_id?: number;
  cpu_cores: number;
  memory_mb: number;
  swap_mb: number;
  disk_total_bytes: number;
  cpu_usage_fraction: number;
  memory_usage_bytes: number;
  uptime_seconds: number;
  backupEnabled: boolean;
  backupOffered: boolean;
  backupPaused: boolean;
}

export interface ContainerDisk {
  key: string;
  size_bytes: number;
}

export interface ContainerDetail {
  vmid: number;
  name: string;
  node: string;
  status: string;
  cpu_cores: number;
  memory_mb: number;
  swap_mb: number;
  swap_usage_bytes: number;
  disk_total_bytes: number;
  disks: ContainerDisk[];
  cpu_usage_fraction: number;
  memory_usage_bytes: number;
  uptime_seconds: number;
  ostype: string | null;
  tags: string;
  ip_addresses: GuestInterface[];
  snapshot_count: number;
}

export type ContainerAction = "start" | "shutdown" | "stop";

export interface ContainerActionResult {
  ok: boolean;
  message: string;
}

export { formatBytes, formatRam, formatUptime, statusColor } from "./vmUtils.js";
export type { GuestInterface } from "./vmUtils.js";
export type { SnapshotSummary } from "./vmUtils.js";
export type {
  DiskMetricTimeframe,
  DiskMetricPoint,
  DiskMetricsResponse,
} from "./vmUtils.js";

export async function containerAction(
  vmid: number,
  action: ContainerAction,
  body?: { force?: boolean; timeout?: number }
): Promise<ContainerActionResult> {
  const verb = action === "start" ? "starting" : "stopping";
  try {
    await apiPost<{ status: string }>(`/api/containers/${vmid}/${action}`, body);
    return { ok: true, message: `Container ${verb}…` };
  } catch (err) {
    const apiErr = err as ApiError;
    if (apiErr.status === 502 && apiErr.error === "pve_unavailable") {
      return { ok: false, message: "Proxmox is unavailable. Please try again." };
    }
    if (apiErr.status === 403) {
      return { ok: false, message: "You don't have access to this container." };
    }
    return { ok: false, message: friendlyError(apiErr) };
  }
}
